import FlexColumn from '../../layout/flex/column.gjs';
import Super from '../../core/base.gjs';
import styles from './body.module.scss';

export const ALIGN_ITEMS_DEFAULT = 'flex-start';
export const ALIGN_SELF_DEFAULT = 'stretch';

export default class SpdsModalStandardBody extends Super {
  baseClass = 'spds-modal-standard-body';
  styles = styles;

  get alignItems() {
    return this.args.alignItems ?? ALIGN_ITEMS_DEFAULT;
  }

  get alignSelf() {
    return this.args.alignSelf ?? ALIGN_SELF_DEFAULT;
  }

  <template>
    <FlexColumn
      @alignItems={{this.alignItems}}
      @alignSelf={{this.alignSelf}}
      id={{this.id}}
      class={{this.classes}}
      data-test-spds-modal-standard-body
      ...attributes
    >
      {{yield}}
    </FlexColumn>
  </template>
}
